import React, { ReactElement, useState, useEffect } from 'react';
import './index.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { NavBarProps } from '../navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMobileAlt, faMapMarkerAlt, faEnvelope, faStore } from '@fortawesome/free-solid-svg-icons';
import {
  AffiliateBussinesForm,
  MainModal,
  ModalChildProps,
} from 'presentation/components';
import Routes from 'presentation/routes';

interface AffiliatedButtonProps {
  className?: string;
  children?: React.ReactNode;
}

const AffiliatedButton = ({ className, children }: AffiliatedButtonProps): ReactElement => {
  const [show, setShow] = React.useState<boolean>(false);

  return (
    <>
      <Button
        onClick={() => setShow(true)}
        variant="danger"
        className={className || "btn-block mt-3 title-bryant"}
      >
        {children || (
          <>
            <FontAwesomeIcon icon={faStore}></FontAwesomeIcon> Afilia tu comercio
          </>
        )}
      </Button>
      <MainModal
        title="Afilia tu comercio"
        show={show}
        onHide={() => setShow(false)}
        render={(props: ModalChildProps) => (
          <AffiliateBussinesForm onHide={props.onHide} />
        )}
      />
    </>
  );
};

import { useBrand } from 'core/contexts/BrandContext';

export const Footer = (props: NavBarProps): ReactElement => {
  const newDate = new Date();
  const year = newDate.getFullYear();
  const brand = useBrand();
  const { name: siteName, country, features, social, contact } = brand;
  const whatsappUrl = `https://wa.me/${contact.whatsappNumber.replace(/\D/g, '')}`;
  const [menuSite, setMenuSite] = useState<any[]>([]);

  useEffect(() => {
    if (features.hasPaymentPointsDropdown) {
      setMenuSite(
        props.items.filter(
          (itemMenu) =>
            itemMenu.country === country &&
            itemMenu.title !== 'Descargá ZüApp' &&
            itemMenu.title !== 'Descargar ZüApp' &&
            itemMenu.url !== Routes.downloadApp
        )
      );
    } else {
      // Para GT, excluir los subitems de Puntos de Pago
      setMenuSite(
        props.items.filter(
          (itemMenu) =>
            itemMenu.country === country &&
            itemMenu.title !== 'Descargá ZüApp' &&
            itemMenu.title !== 'Descargar ZüApp' &&
            itemMenu.url !== Routes.downloadApp &&
            itemMenu.title !== 'Linea Revolvente y Tarjeta Privada' &&
            itemMenu.title !== 'Tarjeta de Credito Mastercard'
        )
      );
    }
  }, [props.items, country, features]);

  return (
    <>
      <section className="footer-wrapper">
        <Container fluid className="p-4 footer special-container">
          <Row>
            {/* Columna 1: Logo, descripción y redes sociales */}
            <Col xs={12} md={6} lg={3} className="border-right-footer mt-3 footer-brand-col">
              <div className="footer-section mx-auto text-center text-md-left">
                <img src={brand.logos.main} className={`${brand.logos.class} mb-3`} alt={siteName} style={{ maxWidth: '150px' }} />
                <p className="footer-description text-muted mb-4 text-bryant" style={{ fontSize: '0.9rem' }}>
                  {siteName} - Ofrecemos soluciones financieras accesibles, rápidas y seguras para ayudarte a alcanzar tus metas.
                </p>
                <div className="footer-social-icons justify-content-center justify-content-md-start">
                  <a href={social.facebookUrl} target="_blank" rel="noopener noreferrer" className="zu-circle-icon" aria-label="Facebook">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="zu-circle-icon" aria-label="WhatsApp">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                </div>
              </div>
            </Col>

            {/* Columna 2: Mapa del sitio */}
            <Col xs={12} md={6} lg={3} className="border-right-footer mt-3 footer-sitemap-col">
              <div className="footer-section mx-auto">
                <h5 className="footer-col-title text-center text-md-left">Mapa del sitio</h5>
                <ul className="list-unstyled p-0">
                  {menuSite.map((itenMenu, index) => {
                    return (
                      <li key={index} className="py-1">
                        <NavLink
                          to={itenMenu.url}
                          className="footer-link text-center text-md-left"
                          activeClassName="text-danger font-weight-bold"
                          exact={itenMenu.url === '/' ? true : false}
                        >
                          {itenMenu.title}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Col>

            {/* Columna 3: App Móvil, Afiliados y Bienes */}
            <Col xs={12} md={6} lg={3} className="border-right-footer mt-3 footer-commerce-col">
              <div className="footer-section mx-auto text-center text-md-left">
                <h5 className="footer-col-title text-center text-md-left">Comercios</h5>
                <ul className="list-unstyled p-0 mb-4">
                  <li className="py-1">
                    <Link to="/afiliados" className="footer-link text-center text-md-left">Comercios Afiliados</Link>
                  </li>
                  <li className="py-1">
                    <Link to="/capacitacion" className="footer-link text-center text-md-left">Centro de Capacitación</Link>
                  </li>
                  <li className={features.hasSalesSection ? 'py-1' : 'd-none'}>
                    <Link to="/sales" className="footer-link text-center text-md-left">Bienes en Venta</Link>
                  </li>
                  <li className={features.hasMobileAppSection ? 'py-1' : 'd-none'}>
                    <Link to={Routes.downloadApp} className="footer-link text-center text-md-left">Descargá ZüApp</Link>
                  </li>
                </ul>
                <div className="d-flex justify-content-center justify-content-md-start">
                  <AffiliatedButton className="btn-afilia">
                    <FontAwesomeIcon icon={faStore} /> Afilia tu Comercio
                  </AffiliatedButton>
                </div>
              </div>
            </Col>

            {/* Columna 4: Contacto */}
            <Col xs={12} md={6} lg={3} className="contact-col mt-3 footer-contact-col">
              <div className="footer-section text-center text-md-left mx-auto">
                <h5 className="footer-col-title text-center text-md-left">Contacto</h5>
                <div className="footer-contact-list mt-3">
                  <div className="footer-contact-item">
                    <div className="zu-circle-icon"><FontAwesomeIcon icon={faMapMarkerAlt} /></div>
                    <span>{country === 'GT' ? 'Guatemala City, Guatemala' : 'Managua, Nicaragua'}</span>
                  </div>
                  <div className="footer-contact-item">
                    <div className="zu-circle-icon"><FontAwesomeIcon icon={faEnvelope} /></div>
                    <a href={`mailto:${contact.email}`} aria-label="Correo de atención">{contact.email}</a>
                  </div>
                  <div className="footer-contact-item">
                    <div className="zu-circle-icon"><FontAwesomeIcon icon={faMobileAlt} /></div>
                    <a href={`tel:${contact.phone}`} aria-label="Teléfono">{contact.phone}</a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <footer className="footer-copyright">
        <Container fluid className="special-container">
          <Row className="py-2">
            <Col xs={12} className="text-center text-bryant">
              <small className="d-block d-md-inline mb-1 mb-md-0 mr-md-2">
                <strong>© {siteName} {year} - Todos los derechos reservados.</strong>
              </small>
              <small className="d-block d-md-inline">
                {siteName} es una marca registrada de la empresa{' '}
                <a href={brand.urls.website} target="_blank" rel="noopener noreferrer" className="text-white">
                  FID, S.A.
                </a>
                {features.hasPaymentPointsDropdown && (
                  <span>
                    , institución regulada por la{' '}
                    <a href="http://www.conami.gob.ni/" target="_blank" rel="noopener noreferrer" className="text-white">
                      CONAMI.
                    </a>{' '}
                    |{' '}
                    <Link to={Routes.termsAndConditions} className="text-white text-bryant ml-1">
                      Términos y condiciones de uso
                    </Link>
                  </span>
                )}
              </small>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
